import React from "react";
import s from "./style.module.css";
import Lottie from "lottie-react-web";
import equity from "./equity.json";
import trust from "./trust.json";
import value from "./value.json";
import useContent from "../../../../helpers/useContent";
import Content from "../../../../components/Content";

const AnimationLoops = ({ fill, text, content, src }) => {
  const items = useContent(content);

  const data = { equity, trust, value };

  return (
    <div
      className={s.wrap}
      style={{
        "--fill": fill,
      }}
    >
      <div className={s.img}>
        <Lottie
          speed={1}
          options={{
            animationData: data[src],
            loop: true,
            autoplay: true,
          }}
        />
      </div>
      <h2 className={s.title}>{text}</h2>

      <Content items={items} />
    </div>
  );
};

export default AnimationLoops;
